// extracted by mini-css-extract-plugin
module.exports = {"Membership":"MembershipTag_Membership__jC0k7","Inactive":"MembershipTag_Inactive__3EEu-","MembershipContent":"MembershipTag_MembershipContent__VE2nX"};